const mapping = {
  requested: {
    title: 'Atendimento solicitado. \nAnalise as informações antes de criar o atendimento.',
    icon: '',
  },
  revision: {
    title: 'Atendimento enviado para revisão',
    icon: 'fas fa-question',
  },
  correction: {
    title: 'Atendimento aguardando a correção do tutor',
    icon: 'fas fa-edit fa-xs',
  },
  corrected: {
    title: 'O atendimento foi corrigido pelo solicitante.',
    icon: 'fas fa-check',
   },
  screening: {
    title: 'O atendimento está em processo de triagem.',
    bgIconClass: 'bg-info',
    icon: 'fas fa-search',
  },
  forwarded: {
    title: 'Atendimento encaminhado.',
    bgIconClass: 'bg-primary',
    icon: 'fas fa-ambulance fa-xs',
  },
  hospitalized: {
    title: 'Pet internado na clínica',
    bgIconClass: 'bg-primary',
    icon: 'fas fa-star-of-life',
  },
  medicalRelease: {
    title: 'O pet recebeu alta',
    bgIconClass: 'bg-success',
    icon: 'fas fa-user-md',
  },
  death: {
    title: 'O pet faleceu',
    bgIconClass: 'bg-dark',
    icon: 'fas fa-cross',
  },
  pullout: {
    title: 'O pet está em processo de retirada',
    bgIconClass: 'bg-primary',
    icon: 'fas fa-undo',
  },
  caught: {
    title: 'O pet foi retirado da clínica',
    bgIconClass: 'bg-success',
    icon: 'fas fa-undo',
  },
  done: {
    title: 'O atendimento foi concluído',
    bgIconClass: 'bg-success',
    icon: 'fas fa-check',
  },
  canceled: {
    title: 'O atendimento foi cancelado',
    bgIconClass: 'bg-error',
    icon: 'fas fa-times',
  },
  rejected: {
    title: 'Atendimento rejeitado',
    bgIconClass: 'bg-error',
    icon: 'fas fa-thumbs-down',
  },
    recordAdded: {
    title: '',
    bgIconClass: 'bg-info',
    icon: 'fas fa-notes-medical',
  },
    prescritionAdded: {
    title: '',
    bgIconClass: 'bg-info',
    icon: 'fas fa-prescription-bottle-alt',
  },
    priorityChanged: {
    title: 'Prioridade do atendimento alterada',
    bgIconClass: 'bg-info',
    icon: 'fas fa-exclamation-triangle',
  },
}

export default (status) => mapping[status] || { title: status, icon: 'fas fa-question' }
